import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";

const Visionen = () => {
	useEffect(() => {
		Aos.init({ duration: 1000, delay: 200 });
	}, []);

	return (
		<div
			className="relative w-full bg-cover bg-center flex justify-center items-center px-8 py-10 md:py-28 lg:py-36 h-[50vh] sm:h-[80vh] md:h-[60vh]"
			style={{ backgroundImage: `url('assets/Vision-section.png')` }}>
			<div data-aos="fade-down" className="text-white text-center max-w-7xl">
				<p className="text-xl sm:text-3xl md:text-4xl lg:text-5xl font-bold leading-relaxed">
					We aim to elevate the legal profession in{" "}
					<span className="text-[#C8AD44]">Saudi society</span> by educating and
					empowering individuals and businesses to protect their rights and
					operate with legal confidence.
				</p>
			</div>
		</div>
	);
};

export default Visionen;
